import styled, { css } from 'styled-components';

export const SubTitleStyled = styled.div<{
  addBottomMargin?: boolean;
  isWaiting: boolean;
  showAtolProtected?: boolean;
}>`
  font-style: normal;
  font-size: ${({ theme }) => theme.kallisto.font.size['175']};
  line-height: ${({ theme }) => theme.kallisto.font.lineHeight['250']};
  font-weight: ${({ theme }) => theme.kallisto.font.weight.regular};
  position: relative;
  color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${({ addBottomMargin }) =>
    addBottomMargin &&
    css`
      margin-bottom: 8px;
    `}

  ${({ showAtolProtected }) =>
    showAtolProtected &&
    css`
      min-height: 32px;
    `}
`;

export const LeftSide = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;
